import userAddressHtml from './userAddress.component.html';
import './userAddress.component.scss';

class UserAddressController {
    constructor($scope, $window, $sce) {
        'ngInject';
        this.$scope = $scope;
        this.$sce = $sce;
        this.shopId = $window.shopId;
        this.shopShipmentCountries = $window.shopShipmentCountries;
        this.shopPaymentCountries = $window.shopPaymentCountries;
        this.addressId = '';
        this.type = '';
        this.data = {
            name: '',
            companyName: '',
            firstName: '',
            lastName: '',
            taxNumber: '',
            noTaxNumber: false,
            icoNumber: '',
            address: '',
            city: '',
            zipCode: '',
            country: '',
            invoice: '0'
        };
        this.addressAfterLoading = '';
        this.tmpData = null;
        this.showAllErrors = false;
        this.form = null;
    }

    $onInit() {
        if (this.tmpData !== null && this.tmpData !== '') {
            this.data = JSON.parse(this.tmpData);
        }

        if (this.data.country === '') {
            this.data.country = this.shopCountry;
        }

        if (this.shopId === 6) {
            this.data.invoice = 1;
        }

        this.$scope.$watch(() => this.shopId, (newVal) => {
            if (newVal === 6) {
                this.data.invoice = 1;
            }
        });

        this.data.addressAfterLoading = this.data.address;

        this.$scope.$watch(() => this.data, (newVal, oldVal) => {
            if (newVal.invoice !== oldVal.invoice && newVal.invoice === '0') {
                this.data.taxNumber = '';
            }
        }, true);

        this.$scope.$watch(() => this.data.noTaxNumber, (newVal, oldVal) => {
            if (parseInt(newVal) === 1) {
                this.data.taxNumber = null;
            }
        }, true);

        this.$scope.$watch(() => this.data.invoice, (newVal, oldVal) => {
            if (newVal === '0') {
                this.data.taxNumber = null;
            }
        });

        this.$scope.$watch(() => this.data.country, (newVal, oldVal) => {
            if (this.$scope.$ctrl.form) {
                for (let $$control of this.$scope.$ctrl.form.$$controls) {
                    if ($$control.$name === 'invoiceTaxNumber') {
                        $$control.$setDirty();
                        $$control.$validate();
                    }
                }
            }
        }, true);

        this.$scope.taxNumberPattern = (() => {
            let patterns = {
                CZ: /^CZ\d{8,10}$/,            // Czechy
                AT: /^(ATU)[0-9]{8}$/,         // Austria (musi mieć "U")
                BE: /^BE[0-9]{10}$/,           // Belgia
                DK: /^DK[0-9]{8}$/,            // Dania
                NL: /^NL[0-9]{9}B[0-9]{2}$/,   // Holandia
                LU: /^LU[0-9]{11}$/,           // Luksemburg
                DE: /^DE[0-9]{9}$/,            // Niemcy
                IT: /^IT[0-9]{11}$/,           // Włochy
                EU: /^[A-Z]{2}[A-Z0-9]{5,18}$/ // Uniwersalny wzór UE
            };

            return {
                test: (value) => {
                    switch (this.shopId) {
                        case 4: // CZ (pattern: CZ lub EU)
                            return patterns.CZ.test(value) || patterns.EU.test(value);
                        case 5: // AT
                            return this.data.country === 'AT' ? patterns.AT.test(value) : true;
                        case 6: // EU
                            return patterns[this.data.country]
                                ? patterns[this.data.country].test(value)
                                : false;
                        default:
                            return true;
                    }
                }
            };
        })();
    }

    getCountries(type) {
        type = parseInt(type);
        switch (type) {
            case 0:
                return this.shopPaymentCountries;
            case 1:
                return this.shopShipmentCountries;
        }

        return [];
    }

    submitForm() {
        this.updateHiddenField();

        if (this.form.$valid) {
            document.getElementById('userAddressForm').submit();
        }
    }

    updateHiddenField() {
        document.getElementById('hiddenType').value = this.type;
        document.getElementById('hiddenInvoice').value = this.data.invoice;
        document.getElementById('hiddenNoTaxNumber').value = this.data.noTaxNumber;
    }

    getAddressPattern() {
        return '^(?=.*[A-Za-z])(?=.*\\d).+$';
    }

    test() {
        this.form.$$setSubmitted();
    }

    get postUrl() {
        let postUrl = '/user/users/addressAddEdit';

        if (this.addressId !== '') {
            postUrl = postUrl + '/' + this.addressId;
        }

        return postUrl;
    }

    get shopCountry() {
        return window.shopCountry;
    }

    get isNameRequired() {
        return this.shopId === 2 ||
            this.shopId === 5 ||
            parseInt(this.data.invoice) === 0 ||
            parseInt(this.data.invoice) === 1 && (
                !this.data.companyName ||
                this.data.companyName && this.data.companyName.length === 0 ||
                !this.data.taxNumber ||
                this.data.taxNumber && this.data.taxNumber.length === 0
            )
    }

    get isCompanyNameRequired() {
        return parseInt(this.data.invoice) === 1;
    }

    get isTaxNumberRequired() {
        return !(
            parseInt(this.data.invoice) === 0 ||
            this.shopId === 2 ||
            this.shopId === 5 && this.data.noTaxNumber === true ||
            this.shopId === 4 && this.data.country === 'CZ'
        );
    }

    get isTaxNumberInputDisplayed() {
        return parseInt(this.data.invoice) === 1;
    }

    get isTaxNumberRequiredInputDisplayed() {
        return this.isTaxNumberInputDisplayed && this.isTaxNumberRequired;
    }

    get isTaxNumberNotRequiredInputDisplayed() {
        return this.isTaxNumberInputDisplayed && !this.isTaxNumberRequired;
    }

    get isIcoNumberInputDisplayed() {
        return parseInt(this.data.invoice) === 1 && this.shopId === 4;
    }

    get isIcoNumberInputRequired() {
        return this.data.country === 'CZ';
    }

    get isIcoNumberRequiredInputDisplayed() {
        return this.isIcoNumberInputDisplayed && this.isIcoNumberInputRequired;
    }

    get isIcoNumberNotRequiredInputDisplayed() {
        return this.isIcoNumberInputDisplayed && !this.isIcoNumberInputRequired;
    }
}

let userAddressComponent = {
    bindings: {
        'addressId': '@',
        'type': '@',
        'tmpData': '@'
    },
    template: userAddressHtml,
    controller: UserAddressController
}

export default userAddressComponent;
